import EventNotification from '../../interfaces/eventNotification/EventNotification';

/** These existing server events change training work; reading an inbox item does not. */
export const isTrainingWorkNotification = (notification: Pick<EventNotification, 'type'>) =>
  notification.type === 'TrainingAssignment' || notification.type === 'External Training Credit';

export interface TrainingNotificationContext {
  authenticatedUserId?: string;
  employeeId?: string;
  organizationId?: number;
  impersonatedUserId?: string | null;
}

/** A connection may outlive an organization switch; never replay its old tenant's work alerts. */
export function matchesTrainingNotificationContext(notification: EventNotification, context: TrainingNotificationContext): boolean {
  if (!context.authenticatedUserId || context.impersonatedUserId) return false;
  if (!notification.notifies?.id || notification.notifies.id !== (context.employeeId || context.authenticatedUserId)) return false;
  const recipientOrganization = notification.notifies?.organization?.id;
  return recipientOrganization != null && context.organizationId != null && recipientOrganization === context.organizationId;
}

const trainingDayFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit',
});

/** Existing API availability uses Chicago calendar days, independently of the employee display zone. */
export function trainingAvailabilityDay(now = new Date()): string {
  const parts = trainingDayFormatter.formatToParts(now);
  return ['year', 'month', 'day'].map(type => parts.find(part => part.type === type)!.value).join('-');
}

/** Check the business date, not elapsed 24-hour intervals: Chicago days can be 23 or 25 hours. */
export function subscribeTrainingAvailabilityDay(onChanged: () => void): () => void {
  let day = trainingAvailabilityDay();
  const timer = window.setInterval(() => {
    const next = trainingAvailabilityDay();
    if (next === day) return;
    day = next;
    onChanged();
  }, 60_000);
  return () => window.clearInterval(timer);
}
